import React from 'react'
import { Provider } from "react-redux";
import { RouterApp } from './config/router/RouterApp'
import store from './store/store';
import './config/i18n_config/i18n'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';
import { Elements } from '@stripe/react-stripe-js';
import { stripe_key } from './store/constants';
import { loadStripe } from '@stripe/stripe-js';


const stripePromise = loadStripe(stripe_key);

function App() {
    return (
        <Provider store={store}>
            <Elements stripe={stripePromise}>
            <RouterApp />
            </Elements>
        </Provider>
    )
}

export default App